<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddCoursetypeDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="type"
          label="课程类型名称"
          align="center"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="appointmenttypeid"
          label="预约类型"
          align="left"
          :filters="this.appointmenttypeData"
          :filter-method="filterAppointmentType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterAppointmentType(scope.row)"
              disable-transitions
              >{{ scope.row.appointmenttypeid }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditCoursetype(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoursetype(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addCoursetypeDialog.show"
        :isShow="addCoursetypeDialog.show"
        :dialogRow="addCoursetypeDialog.dialogRow"
        :appointmenttypeList="addCoursetypeDialog.appointmenttypeList"
        @getCourseTypeList="getCourseTypeList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getCoursetypes, deleteCoursetype } from "@/api/coursetypenew";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      appointmenttypeData: [],
      format_appointment_type_list: {},
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addCoursetypeDialog: {
        show: false,
        dialogRow: {},
        appointmenttypeList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getCourseTypeList();
  },
  methods: {
    /**
     * 格式化状态
     */
    filterAppointmentType(value, item) {
      return this.format_appointment_type_list[value] == item.appointmenttypeid;
    },
    formatterAppointmentType(item) {
      const type = parseInt(item.appointmenttypeid);
      console.log(this.format_appointment_type_list[type]);
      return this.format_appointment_type_list[type];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getCourseTypeList() {
      const para = this.courseData;
      getCoursetypes(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.totalSize;
        this.tableData = res.data.data.data;
        this.format_appointment_type_list =
          res.data.data.formatAppointmentTypeList;
        this.appointmenttypeData = res.data.data.appointmentTypeArrayList;
        var appointmenttypedata = {
          appointmenttypeList: this.appointmenttypeData,
        };
        this.addCoursetypeDialog.appointmenttypeList = appointmenttypedata;
      });
    },
    // 显示添加预约类型弹窗
    showAddCoursetypeDialog(val) {
      this.$store.commit("SET_COURSETYPE_DIALOG_TITLE", val);
      this.addCoursetypeDialog.show = true;
    },
    hideAddFundDialog() {
      this.addCoursetypeDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getCourseTypeList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getCourseTypeList();
    },
    // 编辑操作方法
    onEditCoursetype(row) {
      console.log(row);
      var param = Object.assign({}, row);
      this.addCoursetypeDialog.dialogRow = {
        param,
      };
      this.showAddCoursetypeDialog();
    },
    // 删除数据
    onDeleteCoursetype(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteCoursetype(row.id).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.type + ")课程类型操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getCourseTypeList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


